<template>
  <div class="empty">
    <FontAwesomeIcon v-if="icon" :icon="'fa-light fa-' + icon" class="empty__icon" />
    <span class="empty__text">{{ text }}</span>
    <button
      v-if="action && Object.values(action).length"
      v-tooltip="{ title: action.tooltip, hide: !action.tooltip }"
      class="btn btn-primary"
      @click="clickAction(action.action)"
    >
      <FontAwesomeIcon v-if="action.icon" :icon="'fa-light fa-' + action.icon" class="me-2" />
      {{ action.title }}
    </button>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  name: "EmptyBlock",
  components: { FontAwesomeIcon },
  props: {
    text: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
      default: "",
    },
    action: {
      type: Object,
      required: false,
      default: null,
    },
  },
  methods: {
    clickAction(action) {
      this.$emit(action);
    },
  },
};
</script>

<style lang="scss" scoped>
.empty {
  background-color: $m-color_20;
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  flex-direction: column;
  gap: 15px;

  @include dark-theme {
    background-color: $m-color_19;
  }

  &__icon {
    opacity: 0.2;
    font-size: 45px;
  }
}
</style>
